// @flow
import React from 'react';
import {Provider} from 'react-redux';
import {BrowserRouter as Router} from 'react-router-dom';
import {getStore} from './store';
import App from './App';
import queryString from 'query-string';
import {setCookie} from './utils/cookies';

window.loadUrlInfo = () => {
  const parsedSearch = queryString.parse(document.location.search);
  const utmProperties: {[key: string]: any} = {
    utm_campaign: parsedSearch.utm_campaign || undefined,
    utm_source: parsedSearch.utm_source || undefined,
    utm_medium: parsedSearch.utm_medium || undefined,
    user_referrer: document.referrer || undefined,
  };
  if (parsedSearch.utm_term) utmProperties.utm_term = parsedSearch.utm_term;
  if (parsedSearch.utm_content)
    utmProperties.utm_content = parsedSearch.utm_content;
  setCookie('tl_u', btoa(JSON.stringify(utmProperties)));
};

// Store valuable url information
window.loadUrlInfo();

const store = getStore();

export default (
  <Router basename={'/admin'}>
    <Provider store={store}>
      <App />
    </Provider>
  </Router>
);
